;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.accordion = (function () {
    const initialize = function () {
      const $accordion = $('.accordion')

      // $accordion.find('.js-add-accordion-trigger').each( (i, el) => {
      //   console.log('making an accordion trigger...', el)
      //   const $container = $(el)
      //   $container.wrap('<div class="accordion__trigger_wrap"/>')
      //   $container.after('<div class="accordion__trigger" />')
      // })

      $accordion.find('.accordion__content').slideUp()

      $accordion.find('.accordion__trigger').click(function (e) {
        e.preventDefault()

        console.log('accordion toggle', e)
        const $self = $(this)
        const $content = $self.closest('.accordion').find('.accordion__content')

        if ($self.closest('.accordion').hasClass('expanded')) {
          $self.closest('.accordion').removeClass('expanded')
          $content.slideUp()
        } else {
          $accordion.removeClass('expanded')
          $content.slideDown()
          $self.closest('.accordion').addClass('expanded')
          setTimeout(function () { $('html,body').animate({ scrollTop: ($self.closest('.accordion').offset().top - 50) }) }, 200)
        }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.accordion.initialize()
  })
}(jQuery, window))
